module.exports = __webpack_public_path__ + "img/sent_docs.b160d982.svg";